import {
  useGetNursingHomeList,
  useServiceProviderAppPhoenixApi,
} from '@pflegenavi/service-provider-frontend/api';
import { type QueryKey, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { ResidentState } from '@pflegenavi/shared/api';

export const GET_RESIDENT_LIST_KEY = (
  tenant: string,
  nursingHomeId: string,
  residentStates?: ResidentState[],
  residentIds?: string[]
): QueryKey => [
  'get-resident-list',
  tenant,
  nursingHomeId,
  {
    residentStates,
    residentIds,
  },
];

export const useInitializeResidents = (): void => {
  const serviceProviderAppPhoenixApi = useServiceProviderAppPhoenixApi();

  const { data } = useGetNursingHomeList();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!data) {
      return;
    }

    for (const nursingHome of data) {
      const key = GET_RESIDENT_LIST_KEY(
        nursingHome.tenant,
        nursingHome.nursingHomeId
      );
      queryClient.prefetchQuery({
        queryKey: key,
        queryFn: () =>
          serviceProviderAppPhoenixApi.getResidentList({
            params: {
              tenant: nursingHome.tenant,
              nursingHomeId: nursingHome.nursingHomeId,
            },
          }),
        initialData: () => queryClient.getQueryData(key),
        initialDataUpdatedAt: () =>
          queryClient.getQueryState(key)?.dataUpdatedAt,
      });
    }
  }, [data, queryClient, serviceProviderAppPhoenixApi]);
};
